import { getProcessTypeData } from './processes';
import Logger from './logger';

const updateBackOfficeData = (args) => {
    if (!args) {
        return;
    }
    try {
        const processTypeData = getProcessTypeData(args);
        Logger.log('processTypeData ->', processTypeData);
        if (processTypeData && window.WC?.Closer) {
            window.WC.Closer._processTypeData = processTypeData;
        }
        Logger.logToCloser(
            `update: before identify -> processTypeData=${JSON.stringify(processTypeData)}`
        );

        if (args.isPush && processTypeData?.tags) {
            delete processTypeData.tags;
            if (processTypeData.additionalData?.tags) {
                delete processTypeData.additionalData.tags;
            }
        }

        window.closer.identify(processTypeData);

        if (args.maximize) {
            window.closer.openWidget();
        }
    } catch (ex) {
        Logger.logToCloser(
            `update: exception -> error=${JSON.stringify({ message: ex.message, stack: ex.stack })}`
        );
    }
};

const update = (args) => {
    if (window.WC.Closer._isInitialized) {
        updateBackOfficeData(args);
    } else {
        document.addEventListener(
            'WCCloserInitialized',
            () => {
                updateBackOfficeData(args);
            },
            { once: true }
        );
    }
};

export default update;
